export default "__VITE_ASSET__IYtwKFcD__"